import React, { useState, useEffect } from "react";
import StaffIDCard from "../inputComponents/StaffIDCard";
const ModalStaffIDCard = (props) => {
  const [itemValues, setItemValues] = useState([]);
  const [itemReferenceNo, setItemReferenceNo] = useState("");

  useEffect(() => {
    setItemValues(props.itemId || []);
    setItemReferenceNo(props.referenceNo || "");
  }, [props.itemId, props.referenceNo]);

  return (
    <>
      <StaffIDCard itemValues={itemValues} itemReferenceNo={itemReferenceNo} />
    </>
  );
};
export default ModalStaffIDCard;
